export default "__VITE_ASSET__uG1FQ0yK__"